import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { basePath } from '../utils/perm'
import { convLang } from '../utils/i18n'
import i18n from '../locale'
import _ from 'lodash'

Vue.use(VueAxios, axios)

const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 60000,
  withCredentials: true
})

const permErr = _.debounce(function () {
  let msg = []
  if (store.getters.permErrs) {
    store.getters.permErrs.forEach((e) => {
      msg.push('<li>' + e.method.toUpperCase() + ' ' + basePath + e.url + '</li>')
    })
  }
  store.dispatch('ResetPermErr')
  let base = 'api.actions.perm.error'
  MessageBox.confirm(
    '<p>' + i18n.t(base + '.desc') + '</p><ul>' + msg.join('') + '</ul>',
    i18n.t(base + '.title'),
    {
      confirmButtonText: i18n.t(base + '.reload'),
      cancelButtonText: i18n.t(base + '.continue'),
      type: 'warning',
      dangerouslyUseHTMLString: true
    }
  ).then(() => {
    window.location.reload()
  }).catch(() => {
  })
}, 1000)

const expired = _.debounce(function () {
  MessageBox.confirm(
    i18n.t('login.logoutConfirm'),
    i18n.t('logout.confirmTitle'),
    {
      confirmButtonText: i18n.t('logout.confirmBtn'),
      cancelButtonText: i18n.t('api.cancelBtn'),
      type: 'warning'
    }
  ).then(() => {
    store.dispatch('FedLogOut').then(() => {
      location.href = '/login'
    })
  }).catch(() => {
  })
}, 1000)

const errMsg = (d) => {
  let m = d.message
  if (d.code) {
    m += ' (Error code: ' + d.code + ')'
  }
  return m
}

const showErrMsg = (msg) => {
  Message({
    message: msg,
    type: 'error',
    duration: 30000,
    showClose: true
  })
}

service.interceptors.request.use(
  config => {
    config.headers['Accept-Language'] = convLang(store.getters.language)
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (response.headers['content-type'] === 'image/png') {
      return
    }
    const d = response.data
    if (d.code !== 0) {
      showErrMsg(errMsg(d))
      return Promise.reject(new Error('error'))
    } else {
      return d
    }
  },
  error => {
    if (axios.isCancel(error)) {
      console.warn('Request Canceled:', error.message)
      return Promise.reject(error)
    }
    let message = error.message
    if (error.response) {
      const res = error.response
      if (res.status === 401) {
        expired()
        return Promise.reject(error)
      }
      if (res.status === 403 && res.data && res.data.code === 14) {
        store.dispatch('AddPermErr', error)
        permErr()
        return Promise.reject(error)
      }
      if (res.status === 409 && res.data &&
        (res.data.code === 4700 ||
          res.data.code === 4704 ||
          res.data.code === 4707 ||
          res.data.code === 95
        )) {
        return Promise.resolve(res.data)
      }
      if (res.data && res.data.message) {
        message = errMsg(res.data)
      }
    }
    showErrMsg(message)
    return Promise.reject(error)
  }
)

export default service
